import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["engine", "clickhouseFields"]
  static values = { persisted: Boolean }

  connect() {
    this.sync()
  }

  sync() {
    const postgres = this.hasEngineTarget && this.engineTarget.value === "pg"
    this.clickhouseFieldsTargets.forEach((element) => {
      element.classList.toggle("hidden", postgres)
    })
  }
}
